import { getName } from '@esentai/core/features/brands/selectors';
import { connect } from 'react-redux';

import Option from '@/components/AutocompleteBase/Option';

const mapStateToProps = (state, { value }) => ({
  label: getName(state, value),
});

export default connect(mapStateToProps)(Option);
